module.exports = __webpack_public_path__ + "img/解决方案_节能_灰.984aa8a3.svg";